import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader, TrueFalseRadio } from "../../../NewBusinessWizard/Components/SharedComponents";
import { incomePaymentDetailsLabels } from "../../../Common/SIPP/IncomePaymentDetails/Resource/Content";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { RetirementAge } from "../../../Common/PaymentsIn/SIPP/RetirementAge";

interface IJSIPPSectionProps extends IProcessComponentProps {}

interface IJSIPPSectionState {}

export class JSIPPSection extends ProcessComponent<IJSIPPSectionProps, IJSIPPSectionState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }
    componentDidMount() {
        super.componentDidMount();
    }

    private getProps(key: string) {
        const { onChange, data, showErrorMsgPopUp, isReview } = this.props;

        return {
            type: key,
            data: data[key],
            isReview: isReview,
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onRef: (ref) => this.appendChild(ref),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
        };
    }

    private onProductChange(changes, product, index) {
        const _product = JSON.parse(JSON.stringify(product));
        for (const key in changes) {
            _product[key] = changes[key];
        }
        const data = this.props.data.SelectedProducts.concat();
        data[index] = _product;
        this.props.onChange({ SelectedProducts: data });
    }

    public render(): JSX.Element {
        let { data } = this.props;
        const productIndex = data.SelectedProducts.findIndex((e) => e.SubAccountType == SubAccountType.JuniorSipp);
        const Product = data.SelectedProducts[productIndex];
        return (
            <>
                {SectionHeader("JSIPP options")}
                {TrueFalseRadio(
                    incomePaymentDetailsLabels.needToProvideAnIncome,
                    "IsIncomePaymentDetailsSelected",
                    Product,
                    (key, value) => {
                        this.onProductChange({ [key]: value }, Product, productIndex);
                    },
                    true,
                    { cssWrapper: "radio-group rg-150 mb-16" }
                )}
                <RetirementAge {...this.getProps("AnnuityAssumptions")} clientInfo={data.ClientDetails} />
                <p className="mb-24">This age/date is used for illustration purposes.</p>

                <hr className="mb-20" />
            </>
        );
    }
}
